// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__G_LOf","infoBtn":"quickbooks_infoBtn__2EI_Y","formBox":"quickbooks_formBox__1NjIm","formFooter":"quickbooks_formFooter__3OhWz"};